import {combine} from 'effector';

import {fetchOrdersGrid, fetchOrdersGridCount} from 'api';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {OrdersGridRawRow} from 'types';

const domain = rootDomain.createDomain('OrdersGridDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchOrdersGrid,
});
export const fetchTotalCountFx = domain.createEffect({
    name: 'fetchOrderListFx',
    handler: fetchOrdersGridCount,
});

export const {
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
    showConfigBlock$,
    showConfigBlockChanged,
    stateReset,
} = createGridListModel({domain});

export const data$ = domain.createStore<OrdersGridRawRow[]>([]);
export const totalCount$ = domain.createStore<number>(0);

export const listState$ = combine({
    data: data$,
    totalCount: totalCount$,
    filters: filters$,
    sortings: sortings$,
    showConfigBlock: showConfigBlock$,
    dataLoading: fetchDataFx.pending || fetchTotalCountFx.pending,
});
